import {FETCH_VACANCY_REQUEST, FETCH_VACANCY_ERROR, FETCH_VACANCY_SUCCES} from '../constants/Vacancy'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function vacancy(state = initialState, action) {
  switch (action.type) {
      case FETCH_VACANCY_REQUEST:
        return {...state, isLoading: true};
      case FETCH_VACANCY_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_VACANCY_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/vacancy.js